import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { AlertDialog, type AlertDialogProps, Typography } from '@didaskill/ui/design-system';

import messages from './ExerciseStatementRemoveDialog.messages';

type ExerciseStatementRemoveDialogProps = AlertDialogProps;

const ExerciseStatementRemoveDialogBase = ({ ...props }: ExerciseStatementRemoveDialogProps) => {
  return (
    <AlertDialog variant={AlertDialog.VARIANTS.WARNING} {...props}>
      <Typography variant={Typography.VARIANTS.BODY_MEDIUM_REGULAR}>
        <FormattedMessage {...messages.TITLE} />
      </Typography>
    </AlertDialog>
  );
};

ExerciseStatementRemoveDialogBase.displayName = 'ExerciseStatementRemoveDialog';

export const ExerciseStatementRemoveDialog = memo(ExerciseStatementRemoveDialogBase);
